<template>
  <v-badge v-if="categorias.length > 0" overlap color="white" class="ml-6">
    <template #badge>
      <span class="text-black">{{ categorias.length }}</span>
    </template>

    <v-btn color="#042333" dark small @click="adicionarProdutosCarrinho">
      <v-icon size="19" class="mr-1">mdi-cart</v-icon>
      adicionar
    </v-btn>
  </v-badge>
</template>

<script>
import {adicionarCategoriaNoCarrinho} from "@/api/compras/MateriaPrima";
import {logout} from "@/helpers";

export default {
  name: "AdicionarMultiplosProdutoAoCarrinho",
  props: {
    categorias: Array
  },
  computed: {
    GRUPO_COMPRA() {
      return this.$store.getters['usuario/getGrupoCompras'];
    }
  },
  methods: {
    adicionarProdutosCarrinho() {
      const callback = item => (item.sugestao_compra_peso > 0 && this.validarLoteMinimo(item));

      const requisicao = {
        grupo_compra: this.GRUPO_COMPRA,
        categorias: this.categorias.filter(callback)
          .map(item => this.formatarCategoriaParaRequisicao(item))
      };

      if (requisicao.categorias.length === 0) return;

      this.$store.dispatch(
        "loading/addRequisicao",
        adicionarCategoriaNoCarrinho(requisicao).then(this.categoriasAdicionadaComSucesso).catch(logout)
      );
    },
    formatarCategoriaParaRequisicao(categoria) {
      const {
        idcategoria,
        tipo_compra,
        sugestao_compra_peso: quantidade,
        sugestao_compra_peso_fixa: sugerido,
      } = categoria;

      return {
        quantidade,
        sugerido,
        tipo_compra,
        idcategoria
      }
    },
    categoriasAdicionadaComSucesso() {
      this.$emit('categorias-adicionadas-carrinho', {});
    },
    validarLoteMinimo(item) {
      if (!item.lote_minimo) return false;

      const qtd_compra = Number(item.sugestao_compra_peso).toFixed(4);
      const modulo = Number((qtd_compra % item.lote_minimo).toFixed(4));

      return (modulo === 0 || modulo === Number(item.lote_minimo));
    }
  }
}
</script>

<style scoped>

</style>
